import React from "react";

export default function Hexagon2() {
  return (
    <svg viewBox="0 0 281.7 284.4" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m7104.3 7108.5-43.3 106.1a30.4 30.4 0 0 0 6.7 33.2l84.8 84.5a30.7 30.7 0 0 0 35.8 5.5l105.4-55.1a31.3 31.3 0 0 0 15.1-18l30.2-97.6a30.4 30.4 0 0 0 -9.7-32.6l-85.4-70.6a30.5 30.5 0 0 0 -29.7-5.3l-91.8 32.6a30.6 30.6 0 0 0 -18.1 17.3"
        fill="#00a88e"
        transform="translate(-7058.7 -7056.9)"
      />
    </svg>
  );
}
